import React from 'react';
import { send } from 'emailjs-com';
import { set } from 'immutable';

function JoinUsForm() {
  const [toSend, setToSend] = React.useState({
    representing_brand: '',
    partnering: '',
    more_information: '',
    title: '-',
    fullname: '',
    email: '',
    phone: '-',
    company: '',
  });

  if (typeof window !== `undefined`) {
    const submitBtn = document.getElementById('submit_btn');
    const joinForm = document.getElementById('joinForm');

    const overflow = document.getElementById('overflow');
    const modal = document.getElementById('modal');

    const checkboxesBlock = document.querySelector('.checkboxes_required');

    const onSubmit = e => {
      e.preventDefault();

      if (
        joinForm.querySelectorAll('input[type="checkbox"]:checked').length > 0
      ) {
        submitBtn.disabled = true;
        send(
          'service_uzys0at',
          'template_yjm7pm8',
          toSend,
          'user_KjsqMolSGB6uAGMIJW8oR'
        )
          .then(response => {
            submitBtn.disabled = true;
            joinForm.reset();
            OpenPopup('Your request send successfully!', 'green');
          })
          .catch(err => {
            submitBtn.disabled = true;
            joinForm.reset();
            OpenPopup(
              'Something went wrong.<br> Please contact us directly!',
              'red'
            );
          });
      } else {
        SelectRequired();
      }
    };

    const OpenPopup = (str, style) => {
      overflow.classList.add('active');
      overflow.classList.add(style);
      modal.innerHTML = str;
    };

    const ClosePopup = e => {
      e.preventDefault();
      overflow.classList.remove(overflow.classList[1]);
      overflow.classList.remove(overflow.classList[0]);
    };

    const SelectRequired = () => {
      checkboxesBlock.classList.add('active');

      let blockUpperHeight = document.querySelector('.roadblock').offsetHeight;
      let headerHeight = document.querySelector('.page-header').offsetHeight;

      if (window.scrollY > blockUpperHeight + headerHeight) {
        window.scroll({
          top: blockUpperHeight + headerHeight,
          behavior: 'smooth',
        });
      }
    };

    const CloseCheckbox = e => {
      e.preventDefault();
      checkboxesBlock.classList.remove('active');
    };

    const handleChange = e => {
      if (
        (e.target.name === 'phone' && e.target.value === '') ||
        (e.target.name === 'title' && e.target.value === '')
      ) {
        setToSend({ ...toSend, [e.target.name]: '-' });
      } else {
        setToSend({ ...toSend, [e.target.name]: e.target.value });
      }
    };

    return (
      <div>
        <div className="join_form">
          <form
            onSubmit={onSubmit}
            id="joinForm"
            className="faq-form join"
            method="post"
          >
            <div className="row checkboxes">
              <div className="one_el">
                <div className="collumn">
                  I'd like to connect and request information about:
                </div>
                <div className="collumn checkboxes_required">
                  <div className="required_message">
                    <button onClick={e => CloseCheckbox(e)}>
                      <svg
                        viewBox="0 0 329.26933 329"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"></path>
                      </svg>
                    </button>
                    Please select an item of query
                  </div>
                  <label htmlFor="representing_brand">
                    <input
                      type="checkbox"
                      name="representing_brand"
                      id="representing_brand"
                      value="Representing my brand;"
                      onChange={e => handleChange(e)}
                    />
                    Representing my brand
                  </label>
                  <label htmlFor="partnering">
                    <input
                      type="checkbox"
                      name="partnering"
                      id="partnering"
                      value="Partnering;"
                      onChange={e => handleChange(e)}
                    />
                    Partnering
                  </label>
                  <label htmlFor="more_information">
                    <input
                      type="checkbox"
                      id="more_information"
                      name="more_information"
                      value="More information;"
                      onChange={e => handleChange(e)}
                    />
                    More information
                  </label>
                  <label htmlFor="create_account">
                    <input
                      type="checkbox"
                      id="create_account"
                      name="create_account"
                      value="Enroll/create an account;"
                      onChange={e => handleChange(e)}
                    />
                    Enroll/create an account
                  </label>
                </div>
              </div>
              <input
                type="text"
                name="title"
                placeholder="Title"
                onChange={e => handleChange(e)}
              />
            </div>
            <div className="row">
              <input
                type="text"
                name="fullname"
                placeholder="Name *"
                required
                onChange={e => handleChange(e)}
              />
              <input
                type="email"
                name="email"
                placeholder="Email *"
                required
                onChange={e => handleChange(e)}
              />
            </div>
            <div className="row">
              <input
                type="text"
                name="phone"
                placeholder="Phone"
                onChange={e => handleChange(e)}
              />
              <input
                type="text"
                name="company"
                placeholder="Company"
                onChange={e => handleChange(e)}
              />
            </div>
            <div className="row">
              <button
                type="submit"
                id="submit_btn"
                className="button button--primary"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
        <div id="overflow">
          <button id="close" onClick={e => ClosePopup(e)}>
            <svg viewBox="0 0 329.26933 329" xmlns="http://www.w3.org/2000/svg">
              <path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"></path>
            </svg>
          </button>
          <div id="modal"></div>
        </div>
      </div>
    );
  } else {
    return <div></div>;
  }
}

export default JoinUsForm;
